import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconUserAt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 11,
			cy: 11,
			r: 11,
			fill: "#E7F5FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 17.5C5.35649 16.2708 6.09247 15.1857 7.10275 14.3999C8.11302 13.6142 9.34584 13.1679 10.625 13.125C13.2 13.125 15.3937 14.9437 16.25 17.5",
			stroke: "#026BB6",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_6660_55331)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M10.8125 4.96875C8.82875 4.96875 7.21875 6.57875 7.21875 8.5625C7.21875 10.5462 8.82875 12.1562 10.8125 12.1562H12.6094V11.4375H10.8125C9.25281 11.4375 7.9375 10.1222 7.9375 8.5625C7.9375 7.00281 9.25281 5.6875 10.8125 5.6875C12.3722 5.6875 13.6875 7.00281 13.6875 8.5625V9.07641C13.6875 9.36031 13.4323 9.64062 13.1484 9.64062C12.8645 9.64062 12.6094 9.36031 12.6094 9.07641V8.5625C12.6094 7.57063 11.8044 6.76562 10.8125 6.76562C9.82063 6.76562 9.01562 7.57063 9.01562 8.5625C9.01562 9.55437 9.82063 10.3594 10.8125 10.3594C11.3084 10.3594 11.7612 10.1581 12.0847 9.83109C12.3183 10.1509 12.7208 10.3594 13.1484 10.3594C13.8564 10.3594 14.4062 9.78438 14.4062 9.07641V8.5625C14.4062 6.57875 12.7962 4.96875 10.8125 4.96875ZM10.8125 9.64062C10.2159 9.64062 9.73438 9.15906 9.73438 8.5625C9.73438 7.96594 10.2159 7.48438 10.8125 7.48438C11.4091 7.48438 11.8906 7.96594 11.8906 8.5625C11.8906 9.15906 11.4091 9.64062 10.8125 9.64062Z",
				fill: "#026BB6"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6660_55331",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 8.625,
				height: 8.625,
				fill: "white",
				transform: "translate(6.5 4.25)"
			})
		}) })
	]
});
export default SvgIconUserAt;
